import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AuthService } from './../../../services/API/auth/auth.service';
import { AppVersionService } from './../../../services/app-version/app-version.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  disabled = true;

  userName = "";
  AppName = "";
  rol = "";

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setDivHeight();
  }

  constructor(public router: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, public authService: AuthService, private appVersionService: AppVersionService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.userName = (localStorage.getItem('appUserName') || "");
    this.AppName = (localStorage.getItem('appAppName') || "");
  }

  ngOnInit() {
    this.rol = (localStorage.getItem('appAuthRol') || '');
    this.setDivHeight();
    this.appVersionService.showPendingUpdateFailedDialogIfNeeded();
  }

  setDivHeight() {
    const windowHeight = window.innerHeight;
    const mainContentElement = document.getElementById('mainContent'); 
    if (mainContentElement) {
      mainContentElement.style.height = (windowHeight-60) + 'px';
    }
    const mainMenuElement = document.getElementById('mainMenu');
    if (mainMenuElement) {
      if (this.mobileQuery.matches) {
        mainMenuElement.style.height = '';
        mainMenuElement.style.top = '60px';
        mainMenuElement.style.bottom = '0px';
      } else {
        mainMenuElement.style.height = (windowHeight - 60) + 'px';
        mainMenuElement.style.top = '';
        mainMenuElement.style.bottom = '';
      }
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  logout() {
    this.authService.logout();
  }

  userRolCheck(permission: string){
    return this.authService.userRolCheck(permission);
  }

  canSeePesaje(): boolean {
    if (!this.userRolCheck('permiso_pesar')) {
      return false;
    }
    const raw = (localStorage.getItem('allowed_scales_count') || '').trim();
    const n = raw === '' ? NaN : parseInt(raw, 10);
    if (isNaN(n)) {
      // If not loaded yet, keep current behavior (permission-based).
      return true;
    }
    return n > 0;
  }

}
